<template>
  <a-alert v-if="type === 'history'" :message="text" type="error" @click="showModal" style="cursor:pointer;"/>
  <a-button v-else size="small" type="primary" @click="showModal">{{ $t("detail") }}</a-button>
  <a-modal v-model:visible="visible"
           :title="$t('detail')"
           style="width: 90%;top: 20px"
           :footer="null"
  >
    <a-steps :current="parseInt(task.status)">
      <template #progressDot="{ prefixCls }">
        <span :class="`${prefixCls}-icon-dot`" />
      </template>
      <a-step :title="$t('makeApply')" @click="showDetail('00')"/>
      <a-step :title="$t('produceProgrammes')" @click="showDetail('01')"/>
      <a-step :title="$t('molecularCloning')" @click="showDetail('02')"></a-step>
      <a-step :title="$t('microinjection')" @click="showDetail('03')"/>
      <a-step :title="$t('f0mice')" @click="showDetail('04')"/>
      <a-step :title="$t('f1mice')" @click="showDetail('05')"/>
      <a-step :title="$t('ArrangeTransfer')" @click="showDetail('06')"/>
      <a-step :title="$t('ConfirmCompletion')" @click="showDetail('07')"/>
    </a-steps>
    <a-divider/>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane key="00" :tab="$t('makeApply')">
        <a-descriptions>
          <a-descriptions-item :label="$t('taskIndex')">{{ task.taskindex }}</a-descriptions-item>
          <a-descriptions-item :label="$t('animalType')">
            <option-tag :option-list="animalTypeList" :option-val="task.animaltype"></option-tag>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('geneName')">{{ task.genename }}</a-descriptions-item>
          <a-descriptions-item :label="$t('editType')">
            <option-tag :option-list="editTypeList" :option-val="task.edittype"></option-tag>
            <a-tag color="#108ee9" v-if="task.edittype === '07'">{{ task.otheredit }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('belongUser')">{{ task.userName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('createTime')">{{ formatDate(task.createtime) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('description')">{{ task.description }}</a-descriptions-item>
        </a-descriptions>
        <div style="width: 100%">
          <a-alert
              v-for="file in task.fileList"
              :key="file.id"
              :message="file.realname"
              type="success"
              :showIcon="true"
              @click="downLoad(file.id, file.realname)"
              style="margin-top: 10px;cursor: pointer"
          >
          </a-alert>
        </div>
        <div style="margin-top: 20px">
          <a-button type="primary" v-if="task.status === '00' && isAdmin" @click="nextStep('01')">{{
              $t("nextStep")
            }}
          </a-button>
        </div>
      </a-tab-pane>
      <a-tab-pane key="01" :tab="$t('produceProgrammes')" :disabled="showTabs('01')">
        <produce-programmes v-if="activeKey === '01'" :task-id="taskId" @programmesComplete="changeStatus" @restart="restart"/>
      </a-tab-pane>
      <a-tab-pane key="02" :tab="$t('molecularCloning')" :disabled="showTabs('02')">
        <task-status v-if="activeKey === '02'"  :task-id="taskId" :status="'02'" @changeStatus="changeStatus" @restart="restart"></task-status>
      </a-tab-pane>
      <a-tab-pane key="03" :tab="$t('microinjection')" :disabled="showTabs('03')">
        <task-status v-if="activeKey === '03'" :task-id="taskId" :status="'03'" @changeStatus="changeStatus" @restart="restart"></task-status>
      </a-tab-pane>
      <a-tab-pane key="04" :tab="$t('f0mice')" :disabled="showTabs('04')">
        <task-status v-if="activeKey === '04'" :task-id="taskId" :status="'04'" @changeStatus="changeStatus" @restart="restart"></task-status>
      </a-tab-pane>
      <a-tab-pane key="05" :tab="$t('f1mice')" :disabled="showTabs('05')">
        <task-status v-if="activeKey === '05'" :task-id="taskId" :status="'05'" @changeStatus="changeStatus" @restart="restart"></task-status>
      </a-tab-pane>
      <a-tab-pane key="06" :tab="$t('ArrangeTransfer')" :disabled="showTabs('06')">
        <task-status v-if="activeKey === '06'" :task-id="taskId" :status="'06'" @changeStatus="changeStatus" @restart="restart"></task-status>
      </a-tab-pane>
      <a-tab-pane key="07" :tab="$t('ConfirmCompletion')" :disabled="showTabs('07')">
        <task-status v-if="activeKey === '07'" :task-id="taskId" :status="'07'" @changeStatus="changeStatus" @restart="restart"></task-status>
      </a-tab-pane>
      <a-tab-pane key="08" :tab="$t('hasComplete')" :disabled="showTabs('08')">
        <a-result
            status="success"
            :title="$t('orderCompleted')"
            sub-title="This order has been completed!"
        >
        </a-result>
      </a-tab-pane>
    </a-tabs>
    <a-divider orientation="left">{{ $t("history") }}</a-divider>
    <div style="width: 100%">
      <task-detail v-for="item in taskList" :key="item.id"
                   type="history"
                   :text="item.taskindex + ' ' + formatDate(item.updatetime)"
                   :task-id="item.id"
      ></task-detail>
    </div>
  </a-modal>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/13 15:02
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import ProduceProgrammes from "@/components/task/produceProgrammes";
import TaskStatus from "@/components/task/taskStatus";
import OptionTag from "@/components/public/optionTag";
import $ from "jquery"

export default {
  name: "taskDetail",
  components: {OptionTag, TaskStatus, ProduceProgrammes, VLoading},
  props: {
    taskId: String,
    type: String,
    text: String
  },
  data() {
    return {
      loading: false,
      visible: false,
      activeKey: "1",
      task: {},
      taskList: []
    }
  },
  mounted() {
  },
  methods: {
    addAnimate(){
      $(".cibrStep").removeClass("cibrStep")
      $(".ant-steps-item-active").prev().find(".ant-steps-item-tail").addClass("cibrStep");
    },
    formatDate(val) {
      return util.dateFormat(val, "YYYY-MM-DD");
    },
    restart() {
      this.visible = false;
      this.$emit("changeStatus");
      this.initPage();
    },
    changeStatus() {
      this.initPage();
      this.$emit("changeStatus");
    },
    nextStep(status) {
      var post = {
        status: status,
        taskId: this.taskId
      }
      util.$post("/task/detail/apply/nextStep", post, () => {
        util.submitSuccess();
        this.$emit("changeStatus");
        this.initPage();
      }, this.showMask, this.hideMask);
    },
    downLoad: function (fileId, fileName) {
      console.log(fileId, fileName)
      util.commonDownload(fileId, fileName);
    },
    showDetail(val) {
      if (parseInt(this.task.status) >= parseInt(val)) {
        this.activeKey = val;
      }
    },
    showTabs(val) {
      return parseInt(this.task.status) < parseInt(val)
    },
    showModal() {
      this.visible = true;
      this.initPage();
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      var post = {
        taskId: this.taskId
      }
      util.$post("/task/detail/initPage", post, (res) => {
        this.task = res.task;
        this.taskList = res.taskList;
        this.activeKey = this.task.status;
        setTimeout(()=>{
          this.addAnimate();
        }, 200)
      }, this.showMask, this.hideMask);
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isGeneticAdmin && this.task.completestatus !== "90" && this.task.completestatus !== "91";
    },
    statusList(){
      return util.statusList()
    },
    editTypeList(){
      return util.editTypeList();
    },
    animalTypeList(){
      return util.animalTypeList();
    }
  }
}
</script>

<style scoped>
button {
  margin: 3px 3px;
}
</style>